module.exports = __webpack_public_path__ + "static/media/02.cd798893.png";